// extracted by mini-css-extract-plugin
export default {"container":"o0mvxUDWMPVo1qqyMpGv","currentPrice":"kLegh6VwuYgQO9oDb8gQ"};